import React, { ElementType, memo } from "react";
import { HStack, Text } from "@chakra-ui/react";
import colors from "app/colors";
import { IconProps } from "@chakra-ui/icon";

interface IProps {
  color: string;
  unseenCountIcon?: ElementType<IconProps>;
  unseenCountLabel?: string;
  unseenCount?: number;
}

const LeftNavUnseenCount = ({
  color,
  unseenCountIcon: UnseenCountIcon,
  unseenCountLabel = "",
  unseenCount,
}: IProps) => {
  if (!unseenCount) {
    return null;
  }

  if (UnseenCountIcon && unseenCountLabel) {
    return (
      <HStack
        spacing={1}
        px={1}
        rounded="full"
        bg={color}
        fontSize={10}
        color={colors.white}
      >
        <UnseenCountIcon boxSize={3} fill={colors.white} />
        <Text>{`${unseenCountLabel} ${unseenCount}`.trim()}</Text>
      </HStack>
    );
  }

  return (
    <Text rounded="full" bg={color} fontSize={10} color={colors.white} px={2}>
      {unseenCount}
    </Text>
  );
};

export default memo(LeftNavUnseenCount);
